// Pad the name with "_" in order to match the same length as v1/removed-original.js
// and set the column breakpoints on the same column!
window.____newOriginal = function ____newOriginal() {
  console.log("New original");
}
window.____newOriginal();
